/**
 * SPOON code promo.
 *
 * Entering SPOON in the cart applies the code and adds one UmamiSpoon.
 * The cart must already contain any other product. Shopify's discount is
 * what makes that spoon $0 — this script only adds and removes the line.
 * Gift lines are marked with hidden property _promo = spoon-code.
 */
(function spoonCodePromo() {
  const CODE = "SPOON";
  const PROMO_KEY = "_promo";
  const PROMO_VALUE = "spoon-code";
  const SPOON_VARIANT_ID = 45659577352391;
  const MSG_KEY = "up-spoon-code-message";
  const REJECT_KEY = "up-spoon-code-rejected";

  const routes = window.themeVariables && window.themeVariables.routes;
  if (!routes) return;

  let syncing = false;
  let queued = false;
  let queuedApply = false;
  let holdGift = false;
  let quietUntil = 0;

  function variantId(item) {
    return item.variant_id || item.id;
  }

  function isCodeGift(item) {
    return item.properties && item.properties[PROMO_KEY] === PROMO_VALUE;
  }

  function hasSpoonCode(cart) {
    return (cart.discount_codes || []).some((entry) => entry.code.toUpperCase() === CODE);
  }

  function hasQualifyingItem(cart) {
    return cart.items.some((item) => variantId(item) !== SPOON_VARIANT_ID);
  }

  function giftLines(cart) {
    return cart.items.filter(isCodeGift);
  }

  function otherSpoonLines(cart) {
    return cart.items.filter((item) => variantId(item) === SPOON_VARIANT_ID && !isCodeGift(item));
  }

  function desiredGiftQty(cart) {
    if (!hasSpoonCode(cart) || !hasQualifyingItem(cart)) return 0;
    if (otherSpoonLines(cart).length > 0) return 0;
    return 1;
  }

  async function readCart() {
    const response = await fetch(`${routes.cartUrl}.js`, { credentials: "same-origin" });
    return response.json();
  }

  async function updateDiscount(discount) {
    const response = await fetch(`${routes.cartUrl}/update.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount })
    });
    const cart = await response.json();
    if (!response.ok || !Array.isArray(cart.items)) {
      throw new Error(cart.description || cart.message || "Could not apply that code.");
    }
    return cart;
  }

  async function changeQty(key, quantity) {
    const response = await fetch(`${routes.cartChangeUrl}.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    return response.json();
  }

  async function addGift() {
    const response = await fetch(`${routes.cartAddUrl}.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{
          id: SPOON_VARIANT_ID,
          quantity: 1,
          properties: { [PROMO_KEY]: PROMO_VALUE }
        }]
      })
    });
    const cart = await response.json();
    if (!response.ok || cart.status) {
      throw new Error(cart.description || cart.message || "Could not add the free spoon.");
    }
    return readCart();
  }

  function spoonIsFree(cart) {
    const gifts = giftLines(cart);
    const lines = gifts.length ? gifts : otherSpoonLines(cart);
    if (!lines.length) return false;
    return lines.every((item) => item.final_line_price === 0);
  }

  function giftRejected() {
    try {
      return sessionStorage.getItem(REJECT_KEY) === "1";
    } catch (error) {
      return false;
    }
  }

  function setGiftRejected(rejected) {
    try {
      if (rejected) sessionStorage.setItem(REJECT_KEY, "1");
      else sessionStorage.removeItem(REJECT_KEY);
    } catch (error) {
      /* ignore */
    }
  }

  function showMessage(text) {
    const value = text || "";
    try {
      if (value) sessionStorage.setItem(MSG_KEY, value);
      else sessionStorage.removeItem(MSG_KEY);
    } catch (error) {
      /* ignore */
    }
    document.querySelectorAll("cart-discount-code [data-message]").forEach((el) => {
      el.textContent = value;
    });
    clearTimeout(showMessage.timer);
    if (value) {
      showMessage.timer = setTimeout(() => {
        try {
          sessionStorage.removeItem(MSG_KEY);
        } catch (error) {
          /* ignore */
        }
      }, 15000);
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderCodes(root, cart) {
    const list = root.querySelector("[data-codes]");
    if (!list) return;
    const codes = cart.discount_codes || [];
    if (!codes.length) {
      list.hidden = true;
      list.innerHTML = "";
      return;
    }
    list.hidden = false;
    list.innerHTML = codes.map((entry) => {
      const code = escapeHtml(entry.code);
      const note = entry.applicable === false ? " (not applied)" : "";
      return `<li class="cart-discount__code"><span>${code}${note}</span><button type="button" class="cart-discount__remove" data-remove-code="${code}">Remove</button></li>`;
    }).join("");
  }

  function paint(cart) {
    document.querySelectorAll("cart-discount-code").forEach((el) => renderCodes(el, cart));
  }

  function cartNeedsWork(cart) {
    return !!cart && Array.isArray(cart.items) && (hasSpoonCode(cart) || giftLines(cart).length > 0);
  }

  function publish(cart) {
    if (!cart || cart.status) return;
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.reload();
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: { cart }
    }));
    if (typeof window.upcartRefreshCart === "function") window.upcartRefreshCart();
  }

  function discountFieldReady() {
    const host = document.querySelector("#upCart");
    const root = host && host.shadowRoot;
    if (!root) return false;
    return !!root.querySelector(".upcart-discount-code-module input, .upcart-discount-code-input");
  }

  function showDiscountField() {
    const settings = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
    if (!settings) return;
    settings.discountCodeModule = true;
    settings.discountCodePlaceholder = "";
    settings.discountCodeButtonText = "Apply";
    if (showDiscountField.refreshed || discountFieldReady()) {
      placeDiscountField();
      return;
    }
    showDiscountField.refreshed = true;
    if (typeof window.upcartRefreshCart === "function") window.upcartRefreshCart();
  }

  function upcartRoot() {
    const host = document.querySelector("#upCart");
    return host && host.shadowRoot;
  }

  function isBefore(node, anchor) {
    if (!node || !anchor || node.parentElement !== anchor.parentElement) return false;
    return (node.compareDocumentPosition(anchor) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
  }

  function placeDiscountField() {
    if (placeDiscountField.placing) return;
    const root = upcartRoot();
    if (!root) return;
    const module = root.querySelector(".upcart-discount-code-module");
    const skeleton = root.querySelector(".upcart-discount-code-module-skeleton");
    const guarantee = root.querySelector(".upcart-addons");
    const anchor = root.querySelector(".upcart-addons-skeleton") || guarantee;
    if (!module || !anchor || !anchor.parentElement) return;

    if (!isBefore(module, anchor) || (skeleton && !isBefore(skeleton, anchor))) {
      placeDiscountField.placing = true;
      const parent = anchor.parentElement;
      if (skeleton && skeleton.parentElement === parent) parent.insertBefore(skeleton, anchor);
      if (module.parentElement === parent) parent.insertBefore(module, anchor);
      placeDiscountField.placing = false;
    }

    let label = module.querySelector(".up-discount-label");
    if (!label) {
      label = document.createElement("p");
      label.className = "up-discount-label";
      label.textContent = "Discount code";
      module.insertBefore(label, module.firstChild);
    }
    const compact = window.matchMedia("(max-width: 749px)").matches;
    label.style.setProperty("margin", compact ? "0 0 6px" : "0 0 14px", "important");
    label.style.setProperty("font-size", compact ? "13px" : "14px", "important");
    module.style.setProperty("padding", compact ? "8px 10px" : "14px 14px 16px", "important");
    module.style.setProperty("margin-bottom", compact ? "8px" : "16px", "important");
    const input = module.querySelector("input");
    if (input && input.placeholder) input.placeholder = "";
    if (input) input.style.setProperty("min-height", compact ? "40px" : "48px", "important");
    const button = module.querySelector("button, input[type='submit']");
    if (button) {
      button.style.setProperty("min-height", compact ? "40px" : "48px", "important");
      button.style.setProperty("height", "auto", "important");
      button.style.setProperty("padding", compact ? "0 14px" : "0 22px", "important");
      button.style.setProperty("align-self", "stretch", "important");
    }
    quietSpoonError(module);
  }

  function quietSpoonError(module) {
    const input = module.querySelector("input");
    const typed = (input && input.value || "").trim().toUpperCase();
    const quiet = holdGift || Date.now() < quietUntil || typed === CODE;
    module.classList.toggle("up-spoon-quiet", quiet);
  }

  function bindSpoonApply() {
    const root = upcartRoot();
    if (!root || bindSpoonApply.bound) return;
    bindSpoonApply.bound = true;
    root.addEventListener("submit", onSpoonSubmit, true);
    root.addEventListener("click", onSpoonSubmit, true);
  }

  function onSpoonSubmit(event) {
    const form = event.target.closest && event.target.closest(".upcart-discount-code-module form");
    if (!form || !form.contains(event.target)) return;
    if (event.type === "click" && !event.target.closest("button")) return;
    const input = form.querySelector("input");
    if (!input || input.value.trim().toUpperCase() !== CODE) return;
    event.preventDefault();
    event.stopPropagation();
    applySpoonQuietly(input);
  }

  function watchDiscountField() {
    const root = upcartRoot();
    if (!root || root.querySelector("style[data-up-discount]")) {
      placeDiscountField();
      return;
    }
    const style = document.createElement("style");
    style.dataset.upDiscount = "true";
    style.textContent = [
      ".upcart-discount-code-module {",
      "  margin: 0 0 16px;",
      "  padding: 14px 14px 16px;",
      "  border: 1.5px solid #1B7F4E;",
      "  border-radius: 12px;",
      "  background: #F3F8F4;",
      "}",
      ".up-discount-label {",
      "  margin: 0 0 14px !important;",
      "  font-size: 14px;",
      "  font-weight: 700;",
      "  line-height: 1.2;",
      "  color: #111111;",
      "}",
      ".upcart-discount-code-module form {",
      "  display: flex !important;",
      "  align-items: stretch !important;",
      "  gap: 12px !important;",
      "}",
      ".upcart-discount-code-module .upcart-discount-code-input-wrapper {",
      "  flex: 1 1 auto;",
      "  min-width: 0;",
      "}",
      ".upcart-discount-code-module .upcart-discount-code-input {",
      "  border: 1.5px solid #1B7F4E !important;",
      "  min-height: 48px !important;",
      "  box-sizing: border-box !important;",
      "}",
      ".upcart-discount-code-module button,",
      ".upcart-discount-code-module input[type='submit'] {",
      "  background: #1B7F4E !important;",
      "  color: #ffffff !important;",
      "  border-color: #1B7F4E !important;",
      "  align-self: stretch !important;",
      "  height: auto !important;",
      "  min-height: 48px !important;",
      "  padding: 0 22px !important;",
      "  box-sizing: border-box !important;",
      "  font-size: 15px !important;",
      "  font-weight: 700 !important;",
      "}",
      ".upcart-discount-code-module button span {",
      "  color: #ffffff !important;",
      "}",
      "@media (max-width: 749px) {",
      "  .upcart-discount-code-module {",
      "    margin: 0 0 8px !important;",
      "    padding: 8px 10px !important;",
      "  }",
      "  .up-discount-label {",
      "    margin: 0 0 6px !important;",
      "    font-size: 13px !important;",
      "  }",
      "  .upcart-discount-code-module form {",
      "    gap: 8px !important;",
      "  }",
      "  .upcart-discount-code-module .upcart-discount-code-input,",
      "  .upcart-discount-code-module button,",
      "  .upcart-discount-code-module input[type='submit'] {",
      "    min-height: 40px !important;",
      "  }",
      "  .upcart-discount-code-module button,",
      "  .upcart-discount-code-module input[type='submit'] {",
      "    padding: 0 14px !important;",
      "    font-size: 14px !important;",
      "  }",
      "}",
      ".upcart-discount-code-module.up-spoon-quiet .DiscountCodeModule_DiscountCodeModule__error__ {",
      "  opacity: 0 !important;",
      "}"
    ].join("");
    root.appendChild(style);
    const observer = new MutationObserver(() => placeDiscountField());
    observer.observe(root, { childList: true, subtree: true });
    placeDiscountField();
  }

  function startUpcart() {
    if (startUpcart.started) return;
    const settings = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
    if (!settings || typeof window.upcartSubscribeCartUpdated !== "function") return;
    startUpcart.started = true;

    settings.discountCodeModule = true;
    settings.discountCodePlaceholder = "";
    settings.discountCodeButtonText = "Apply";

    window.upcartSubscribeCartUpdated(() => {
      if (syncing) return;
      readCart().then((cart) => {
        if (!cartNeedsWork(cart)) return;
        sync(cart, hasSpoonCode(cart) && giftLines(cart).length === 0);
      }).catch(() => {});
    });

    if (typeof window.upcartSubscribeCartOpened === "function") {
      window.upcartSubscribeCartOpened(() => showDiscountField());
    }
    watchDiscountField();
    bindSpoonApply();
    if (!startUpcart.resizeBound) {
      startUpcart.resizeBound = true;
      window.matchMedia("(max-width: 749px)").addEventListener("change", () => placeDiscountField());
    }
  }

  async function waitUntilFree(cart) {
    let updated = cart;
    for (let attempt = 0; attempt < 4; attempt += 1) {
      if (!hasSpoonCode(updated) || !giftLines(updated).length || spoonIsFree(updated)) return updated;
      await new Promise((resolve) => setTimeout(resolve, 250));
      updated = await readCart();
    }
    return updated;
  }

  async function applySpoonQuietly(input) {
    if (holdGift) return;
    holdGift = true;
    quietUntil = Date.now() + 4000;
    const module = input.closest(".upcart-discount-code-module");
    if (module) module.classList.add("up-spoon-quiet");
    try {
      let cart = await readCart();
      if (!hasQualifyingItem(cart)) {
        showMessage("Add another product to your cart, then apply the code.");
        return;
      }
      if (!giftLines(cart).length && !otherSpoonLines(cart).length) {
        cart = await addGift();
      }
      const codes = (cart.discount_codes || []).map((entry) => entry.code);
      if (!codes.some((code) => code.toUpperCase() === CODE)) codes.push(CODE);
      cart = await updateDiscount(codes.join(","));
      cart = await waitUntilFree(cart);
      input.value = "";
      setGiftRejected(spoonIsFree(cart) ? false : true);
      paint(cart);
      publish(cart);
    } catch (error) {
      showMessage(error.message || "Could not update the free spoon.");
    } finally {
      holdGift = false;
      if (queued) {
        const apply = queuedApply;
        queued = false;
        queuedApply = false;
        sync(await readCart(), apply);
      }
    }
  }

  async function removeGifts(cart) {
    let updated = cart;
    for (const gift of giftLines(cart)) {
      updated = await changeQty(gift.key, 0);
    }
    return Array.isArray(updated.items) ? updated : readCart();
  }

  async function sync(cart, fromApply) {
    if (!cart || !Array.isArray(cart.items)) return cart;
    if (holdGift) {
      queued = true;
      queuedApply = queuedApply || fromApply;
      return cart;
    }
    if (syncing) {
      queued = true;
      queuedApply = queuedApply || fromApply;
      return cart;
    }

    syncing = true;
    let updated = cart;
    let changed = false;

    try {
      updated = await readCart();
      if (fromApply) setGiftRejected(false);

      if (hasSpoonCode(updated) && !hasQualifyingItem(updated)) {
        const remaining = (updated.discount_codes || [])
          .map((entry) => entry.code)
          .filter((code) => code.toUpperCase() !== CODE);
        updated = await updateDiscount(remaining.join(","));
        setGiftRejected(false);
        changed = true;
        showMessage("Add another product to your cart, then apply the code.");
      }

      if (giftLines(updated).length && hasSpoonCode(updated) && !spoonIsFree(updated)) {
        updated = await waitUntilFree(updated);
        if (giftLines(updated).length && hasSpoonCode(updated) && !spoonIsFree(updated)) {
          updated = await removeGifts(updated);
          setGiftRejected(true);
          changed = true;
        }
      }

      let desired = desiredGiftQty(updated);
      if (giftRejected() && !fromApply) desired = 0;
      const gifts = giftLines(updated);
      const current = gifts.reduce((sum, item) => sum + item.quantity, 0);

      if (current !== desired) {
        changed = true;
        if (desired === 0) {
          updated = await removeGifts(updated);
        } else if (gifts.length === 0) {
          updated = await addGift();
          updated = await waitUntilFree(updated);
          if (!spoonIsFree(updated)) {
            updated = await removeGifts(updated);
            setGiftRejected(true);
          } else {
            setGiftRejected(false);
          }
        } else {
          updated = await changeQty(gifts[0].key, desired);
          for (const extra of gifts.slice(1)) {
            updated = await changeQty(extra.key, 0);
          }
          if (!Array.isArray(updated.items)) updated = await readCart();
        }
      } else if (fromApply && hasSpoonCode(updated) && hasQualifyingItem(updated) && !giftRejected()) {
        showMessage(spoonIsFree(updated) ? "Free spoon added." : "Code applied.");
      }

      if (changed) {
        paint(updated);
        publish(updated);
      }
      return updated;
    } catch (error) {
      showMessage(error.message || "Could not update the free spoon.");
      return cart;
    } finally {
      syncing = false;
      if (queued) {
        const apply = queuedApply;
        queued = false;
        queuedApply = false;
        sync(await readCart(), apply);
      }
    }
  }

  async function applyFrom(el) {
    const code = el.input.value.trim();
    if (!code || el.applyBtn.disabled) return;
    el.applyBtn.disabled = true;
    try {
      const cart = await readCart();
      if (code.toUpperCase() === CODE && !hasQualifyingItem(cart)) {
        showMessage("Add another product to your cart, then apply the code.");
        return;
      }
      const existing = (cart.discount_codes || []).map((entry) => entry.code);
      if (!existing.some((entry) => entry.toUpperCase() === code.toUpperCase())) existing.push(code);
      const updated = await updateDiscount(existing.join(","));
      el.input.value = "";
      if (code.toUpperCase() === CODE) {
        await sync(updated, true);
      } else {
        const entry = (updated.discount_codes || []).find((item) => item.code.toUpperCase() === code.toUpperCase());
        showMessage(entry && entry.applicable === false ? "That code couldn't be applied." : "Code applied.");
        paint(updated);
        publish(updated);
      }
    } catch (error) {
      showMessage(error.message || "Could not apply that code.");
    } finally {
      el.applyBtn.disabled = false;
    }
  }

  async function removeCode(code, el) {
    if (el.applyBtn.disabled) return;
    el.applyBtn.disabled = true;
    try {
      const cart = await readCart();
      const remaining = (cart.discount_codes || [])
        .map((entry) => entry.code)
        .filter((entry) => entry.toUpperCase() !== code.toUpperCase());
      const updated = await updateDiscount(remaining.join(","));
      showMessage("Code removed.");
      await sync(updated, true);
    } catch (error) {
      showMessage(error.message || "Could not remove that code.");
    } finally {
      el.applyBtn.disabled = false;
    }
  }

  class CartDiscountCode extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === "true") return;
      this.dataset.bound = "true";
      this.input = this.querySelector("input");
      this.message = this.querySelector("[data-message]");
      this.applyBtn = this.querySelector("[data-apply]");

      try {
        const saved = sessionStorage.getItem(MSG_KEY);
        if (saved && this.message) this.message.textContent = saved;
      } catch (error) {
        /* ignore */
      }

      this.applyBtn.addEventListener("click", () => applyFrom(this));
      this.input.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;
        event.preventDefault();
        event.stopPropagation();
        applyFrom(this);
      });
      this.addEventListener("click", (event) => {
        const button = event.target.closest("[data-remove-code]");
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        removeCode(button.getAttribute("data-remove-code"), this);
      });

      readCart().then((cart) => {
        if (this.isConnected) renderCodes(this, cart);
      }).catch(() => {});
    }
  }

  if (!customElements.get("cart-discount-code")) {
    customElements.define("cart-discount-code", CartDiscountCode);
  }

  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail && event.detail.cart;
    if (cartNeedsWork(cart)) sync(cart, false);
  });

  document.addEventListener("cart:refresh", (event) => {
    if (syncing) return;
    const cart = event.detail && event.detail.cart;
    if (cartNeedsWork(cart)) sync(cart, false);
  });

  readCart().then((cart) => {
    if (cartNeedsWork(cart)) sync(cart, false);
  }).catch(() => {});

  const upcartBoot = setInterval(() => {
    startUpcart();
    if (startUpcart.started) clearInterval(upcartBoot);
  }, 300);
  setTimeout(() => clearInterval(upcartBoot), 8000);
})();
